import Phaser from 'phaser';
import { GAME_WIDTH } from '../core/Config';

export type EditorPanelState = {
  visible: boolean;
  worldKey: string;
  worldType: 'village' | 'house';
  mode: string;
  snap: number;
  gridVisible: boolean;
  draftCounts: { collision: number; interactable: number; npc_zone: number; occluder: number };
  lastPayload?: string;
  recentLogs?: string[];
};

const WORLD_TYPE_LABELS: Record<EditorPanelState['worldType'], string> = {
  village: '마을',
  house: '집',
};

export class WorldEditorPanel {
  private readonly container: Phaser.GameObjects.Container;
  private readonly body: Phaser.GameObjects.Text;
  private visibleState = false;

  constructor(private readonly scene: Phaser.Scene) {
    const outer = scene.add.rectangle(0, 0, 520, 420, 0x09101d, 0.97).setStrokeStyle(3, 0x67e8f9, 0.85).setOrigin(0.5);
    const inner = scene.add.rectangle(0, 0, 492, 392, 0x111827, 0.97).setStrokeStyle(2, 0xfde68a, 0.65).setOrigin(0.5);
    const title = scene.add.text(0, -122, '월드 편집 패널', {
      fontSize: '26px',
      color: '#fef3c7',
      fontStyle: 'bold',
    }).setOrigin(0.5);
    this.body = scene.add.text(-210, -88, '', {
      fontSize: '15px',
      color: '#dbeafe',
      lineSpacing: 6,
      wordWrap: { width: 430 },
    });
    this.container = scene.add.container(GAME_WIDTH - 280, 220, [outer, inner, title, this.body]).setDepth(12100).setScrollFactor(0).setVisible(false);
  }

  setVisible(visible: boolean) {
    this.visibleState = visible;
    this.container.setVisible(visible);
  }

  toggle() {
    this.setVisible(!this.visibleState);
  }

  isVisible() {
    return this.visibleState;
  }

  render(state: EditorPanelState) {
    if (!state.visible) {
      this.setVisible(false);
      return;
    }

    this.setVisible(true);
    this.body.setText([
      `월드       ${state.worldKey} (${WORLD_TYPE_LABELS[state.worldType]})`,
      `모드       ${state.mode}`,
      `스냅       ${state.snap}px`,
      `그리드     ${state.gridVisible ? 'ON' : 'OFF'}`,
      `초안 개수  c${state.draftCounts.collision} / i${state.draftCounts.interactable} / n${state.draftCounts.npc_zone} / o${state.draftCounts.occluder}`,
      '',
      '1~4  모드 변경',
      'G    그리드',
      '[ ]  스냅',
      '5    저장',
      '6    다운로드',
      '7    payload 복사',
      '8    전체 복사',
      '0    현재 월드 초기화',
      '',
      '최근 로그',
      ...(state.recentLogs ?? ['- 로그 없음']),
    ]);
  }
}
